import React, { useState } from "react";

import "../styles/lightbox.css";

const Lightbox = ({ images, startIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>
          ×
        </button>
        <div className="lightbox-body">
          <div className="lightbox-image-wrapper">
            <img
              src={images[currentIndex].src}
              alt={`Slide ${currentIndex + 1}`}
              className="lightbox-image"
            />
          </div>
          <p className="lightbox-label">{images[currentIndex]?.label}</p>
        </div>
        {images.length > 1 && (
          <>
            <button className="lightbox-prev" onClick={handlePrev}>
              &#10094;
            </button>
            <button className="lightbox-next" onClick={handleNext}>
              &#10095;
            </button>
          </>
        )}
        {/* <p className="lightbox-counter">
          Slide {currentIndex + 1} of {images.length}
        </p> */}
      </div>
    </div>
  );
};

export default Lightbox;
